import handleResponse from './request/handleProfileResponse'

export default function(api: GlobalFetch) {
  return async function(calendarId: number) {
    const response = await api.fetch(
      `/api/v2/object/logo/id_calendar/${calendarId}`,
      {
        body: '',
        method: 'DELETE',
      },
    )
    return await handleResponse(response)
  }
}
